<template>
	<div class="login wish-input">		
		<img src="../assets/make-a-wish-logo.png" alt="" class="make-a-wish-logo">
		<div class="script-pad">
			<h2>ล็อกอินก่อนนะ</h2>

			<ul class="social-login">
				<li>With Social: </li>
				<li @click="loginViaFacebook"><img src="https://www.jeban.com/images/btn-cir-fb.png"></li>
				<li @click="loginViaGoogle"><img src="https://www.jeban.com/images/btn-cir-G.png"></li>
				<li></li>
			</ul>

			<div class="form">
				<input class="username" type="text" v-model="usernameOrEmail" autofocus placeholder="Username or Email">
				<input class="password" type="password" v-model="password" placeholder="Password">
				<a class="link-button" @click="forgotPassword"><small>Forgot Password?</small></a>

				<button class="filled-button" @click="loginViaEmail">LOGIN</button>
			</div>
		</div>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	export default {
		data () {
			return {
				usernameOrEmail: '',
				password: '',
				infoError: false
			}
		},
		computed: {
			isAuthenticated () {
				return this.$store.getters.isAuthenticated
			},
		},
        mounted () {
			this.$store.dispatch('loadGoogleSDK')
			this.$store.dispatch('loadFacebookSDK')
		},
		methods: {
			loginViaEmail () {
				if(this.usernameOrEmail != '' && this.password != '') {
					this.$store.dispatch('loginViaEmail', {
						usernameOrEmail: this.usernameOrEmail,
						password: this.password,
					})
				} else {
					this.$store.commit(types.SET_ERROR_MSG, 'กรอกข้อมูลสำหรับ Login ให้ครบด้วยนะคะ')
				}
			},
			loginViaFacebook () {
				this.$store.dispatch('loginViaFacebook')
			},
			loginViaGoogle () {
				this.$store.dispatch('loginViaGoogle')
			},
			forgotPassword () {
				this.$swal.fire({
					title: "ลืมรหัสผ่านเหรอจ๊ะ",
					text: "กรอก Username หรือ Email ที่เคยสมัครไว้, แล้วเราจะส่งลิ้งสำหรับ Reset Password ให้ทางอีเมลน้า",
					input: 'text',
					inputAttributes: {
						autocapitalize: 'off'
					},
					showCancelButton: true,
					confirmButtonColor: '#EEB85F',
					showLoaderOnConfirm: true,
					preConfirm: (value) => {
						return 
							fetch(`${config.BASE_URL}/password/reset/send`, {
								method: 'POST',
								body: JSON.stringify({usernameOrEmail: value}),
								headers: new Headers({
									'Content-Type': 'application/json'
								})
							})
							.then(response => {
								console.log(response)
								if (!response.ok) {
									throw new Error(response.statusText)
								}
								return response.json()
							})
							.catch(error => {
								console.log(error)
								$this.$swal.showValidationMessage(
									`Request failed: ${error}`
								)
							})
      						// return 
						// 	axios.post(`${config.BASE_URL}/password/reset/send`, {
						// 		usernameOrEmail: usernameOrEmail
						// 	})
						// 	.then((response) => {
						// 		if (response.data.code !== 0 ) {
						// 			throw new Error(response.data.message)
						// 		}
						// 		return response.json()
						// 	})
						// 	.catch(error => {
						// 		this.$swal.showValidationMessage(
						// 			`Request failed: ${error}`
						// 		)
						// 	})
					},
					allowOutsideClick: () => !this.$swal.isLoading()
				})
				.then((result) => {
					if (result.value) {
						axios.post(`${config.BASE_URL}/password/reset/send`, {
							usernameOrEmail: result.value
						})
						.then(response => {
							console.log(response)
							if (response.data.code === 0) {
								this.$swal.fire({
									text: `ลองเช็คอีเมล "${response.data.data.email}" ดูน้า เราได้ส่งลิ้งสำหรับ Reset Password ไปให้ สาว ๆ เลือกคลิ๊กลิ้งเปลี่ยนรหัสได้จากอีเมลที่สาว ๆ ระบุไว้ได้เลยจ้า`,
									imageUrl: 'https://www.jeban.com/images/gp-check-your-mail.png',
									confirmButtonColor: '#EEB85F'
								})
							} else {
								this.$store.commit(types.SET_ERROR_MSG, response.data.message)
							}
						})
					}
				})
			}
		},
		watch: {
			isAuthenticated (value) {
				if (value) {
					this.$router.push('/')
				}
			}
		}
	}
</script>

<style lang="scss">
	.login {
		min-height: 100vh;
		height: 100%;
		box-sizing: border-box;
		
		background: url('../assets/bg-2020.png') #064D81 no-repeat;
		background-position-x: calc(50% + 60px);
		background-position-y: -259px;
		background-size: 1703.66px auto;

		@media (max-width: 767px) {
			background-image: url('../assets/bg-2020-xs.png');
			background-position-x: center;
			background-position-y: -177.1px;
			background-size: 566.36px auto;

			padding-top: 50px;
		}
	}
	.make-a-wish-logo {
		display: flex;
		width: 500px;
		max-width: 100%;

		margin-left: auto;
		margin-right: auto;
		
		@media (max-width: 767px) {
			width: 370px;
			margin-bottom: 56px;
		}
	}
	.script-pad {
		background: url('../assets/bg-script-pad-1.png') center top transparent repeat-y;
		background-size: 1018px auto;
		position: relative;
		padding: 1rem;

		max-width: 1018px;
		margin: 40px auto 82.5px auto;
		margin-right: auto;

		font-family: 'DB-Heavent-reg';
		font-size: 24px;

		&:before {
			background: url('../assets/bg-script-pad-0.png') center top transparent no-repeat;
			height: 73px;
			top: -73px;
		}
		&:after {
			background: url('../assets/bg-script-pad-2.png') center top transparent no-repeat;
			height: 82.5px;
			bottom: -82.5px;
		}
		&:before, &:after {
			background-size: 1018px auto;
			position: absolute;

			content: '';
			display: block;
			left: 0;
			width: 100%;

			@media (max-width: 767px) {
				background-size: 125% 100%;
			}
		}

		h2 {
			@include font-reg;
			font-size: 38px;
			margin: 0;
		}

		p {
			max-width: calc(1000px - 2rem);
			margin-left: auto;
			margin-right: auto;
			line-height: 1.2;
		}

		a.add-more-wish {
			background: #EEB85F;
			color: white;
			width: 222px;
			height: 52px;
			border-radius: 26px;

			display: flex;
			justify-content: center;
			align-items: center;

			margin: 40px auto 0;

			font-family: 'DB-Heavent-reg';
			font-size: 28px;
			text-decoration: none;
			box-shadow: 0px 3px 6px rgba(0, 0, 0, .16);

			@media (max-width: 767px) {
				margin: 24px auto 0;
			}
		}

		ul.social-login,
		.form {
			max-width: 320px;
			padding: 0 1rem;
			margin: 0 auto;
		}
		ul.social-login {
			margin-top: 2rem;

			display: flex;
			flex-flow: row wrap;
			list-style-type: none;
			justify-content: flex-start;
			align-items: center;

			padding-bottom: 1rem;

			li {
				@include font-reg;

				&:first-child {
					margin-right: .5rem;
				}
				&:last-child {
					width: 100%;
					height: 1rem;
					border-bottom: 2px dotted #ccc;
				}

				img {
					cursor: pointer;
					width: 50px;
					height: 50px;
				}
			}
		}
		.form {
			input {
				font-family: 'DB-Heavent-li';
				font-size: 24px;
				height: 36px;
				border: 0;
				outline: 0;
				background: transparent;
				border-bottom: 2px solid #EEB85F;
				box-sizing: border-box;
				border-radius: 0;

				margin-top: 1rem;
				width: 100%;

				&::placeholder {
					font-style: italic;
					color: #93959A;
				}
			}

			a.link-button {
				margin-left: 0;
				text-decoration: none;
				small {
					font-style: italic;
				}
			}
			button.filled-button {
				margin-top: 1.5rem;
				width: 100% !important;
			}
		}
	}
</style>